import { NotificationTypesEnum } from "../enums";
import { NotificationDto } from "../models/dto/notification.dto";
import { findKey } from 'lodash-es';

export const notificationCauseEntityPropertyToTypeIdsMap: {
	[P in keyof NotificationDto]?: NotificationTypesEnum[];
} = {
	userToFollower: [
		NotificationTypesEnum.FollowRequestAccepted,
		NotificationTypesEnum.NewFollower,
		NotificationTypesEnum.NewFollowerRequest,
		NotificationTypesEnum.NewMutualSubscription,
	],
	eventToUser: [
		NotificationTypesEnum.EventUpdated,
		NotificationTypesEnum.EventCanceled,
		NotificationTypesEnum.EventInstanceCanceled,
		NotificationTypesEnum.EventInvitationAccepted,
		NotificationTypesEnum.EventInvitationDeclined,
		NotificationTypesEnum.UserJoinedEvent,
		NotificationTypesEnum.UserInvitedToEvent,
		NotificationTypesEnum.UserAddedToEventInstanceFromWaitlist,
		NotificationTypesEnum.EventYouAttendedStartsIn10Minutes,
	],
	event: [
		NotificationTypesEnum.YourEventStartsIn24Hours,
		NotificationTypesEnum.YourEventStartsIn1Hour,
		NotificationTypesEnum.CongratsEventPublished,
		NotificationTypesEnum.PersonalizedMailing,
		NotificationTypesEnum.EventMassInvitation,
		NotificationTypesEnum.HostYouFollowCreatedEvent,
		NotificationTypesEnum.UserJoinedDonationBasedEvent,
		NotificationTypesEnum.UserMadeDonationForEvent,
		NotificationTypesEnum.UserEventOrderRefunded,
		NotificationTypesEnum.UserNotifiedEventSpotAvailable,
		NotificationTypesEnum.YouHaveReceivedTicket,
	],
	membership: [
		NotificationTypesEnum.MembershipPaused,
	],
	interest: [
		NotificationTypesEnum.NewSystemInterestCreated,
		NotificationTypesEnum.SystemInterestDeleted,
	],
	userToPastEvent: [
		NotificationTypesEnum.NewReactionToPastEvent,
		NotificationTypesEnum.PastEventPublishedBySweatPal,
		NotificationTypesEnum.NewJournalFromYourSubscription,
	],
	pastEvent: [
		NotificationTypesEnum.EventEnded,
	],
	streamChatRequest: [
		NotificationTypesEnum.NewJoinGroupChatRequest,
		NotificationTypesEnum.JoinGroupChatRequestAccepted,
		NotificationTypesEnum.JoinGroupChatRequestDeclined,
	],
	user: [
		NotificationTypesEnum.NewCommunityProfileAdmin,
	],
	reaction: [
		NotificationTypesEnum.NewCommentOnYourPost,
		NotificationTypesEnum.NewReactionToYourPost,
		NotificationTypesEnum.NewLikeOnYourComment,
		NotificationTypesEnum.NewCommentNearYourComment,
		NotificationTypesEnum.NewReplyToYourComment,
		NotificationTypesEnum.NewLikeOnYourReply,
		NotificationTypesEnum.SomebodyMentionedYou,
	],
	challenge: [
		NotificationTypesEnum.ChallengeStarted,
	],
};

export const getNotificationCauseEntityPropertyByTypeId = (typeId: NotificationTypesEnum): keyof NotificationDto => findKey(
	notificationCauseEntityPropertyToTypeIdsMap,
	(typeIds?: NotificationTypesEnum[]) => typeIds?.includes(typeId)
) as keyof NotificationDto;
